import Vue from 'vue'

// 注册全局组件

import AppLink from '@cps/AppLink'
Vue.component('app-link', AppLink)

import Pack from '@cps/Pack'
Vue.component('pack', Pack)

import ZtInput from '@cps/ZtInput'
Vue.component('zt-input', ZtInput)

import ZtButton from '@cps/ZtButton'
Vue.component('zt-button', ZtButton)

import { $validateRes } from '@utils/vaildate'
Vue.prototype.$validateRes = $validateRes

import format from '@utils/format'
Vue.filter('money', format.money)
Vue.filter('money_relative', format.money_relative)